import React, { useState } from 'react';
import { CheckIcon } from 'lucide-react';
export type Field = {
  name: string;
  label: string;
  type?: 'text' | 'email' | 'tel' | 'textarea' | 'select';
  options?: string[];
  half?: boolean;
  required?: boolean;
};
type Props = {
  fields: Field[];
  submitLabel: string;
  note?: string;
  tone?: 'paper' | 'dark';
};

/** Mock enquiry form — validates presence, then shows a confirmation state. */
export function EnquiryForm({
  fields,
  submitLabel,
  note,
  tone = 'paper'
}: Props) {
  const [sent, setSent] = useState(false);
  const dark = tone === 'dark';
  const labelCls = `type-eyebrow mb-2 block text-[10px] ${dark ? 'text-paper/60' : 'text-coffee/60'}`;
  const inputCls = `type-body w-full rounded-2xl border px-5 py-4 text-sm outline-none transition-colors ${dark ? 'border-paper/20 bg-transparent text-paper placeholder:text-paper/30 focus:border-paper/60' : 'border-oat bg-paper text-ink placeholder:text-ink/30 focus:border-coffee'}`;
  if (sent) {
    return <div className={`flex flex-col items-start gap-4 rounded-3xl border p-10 ${dark ? 'border-paper/20' : 'border-oat bg-paper'}`} data-id="element-62" data-mp="i10j4zs4vt7x">
        <span className={`flex h-11 w-11 items-center justify-center rounded-full ${dark ? 'bg-paper text-coffee' : 'bg-coffee text-paper'}`} data-id="element-63" data-mp="rso4qk20eg1h">
          <CheckIcon className="h-5 w-5" strokeWidth={2} data-id="element-64" data-mp="3v8lg2wbwpu1e" />
        </span>
        <p className={`type-display text-3xl ${dark ? 'text-paper' : 'text-coffee'}`} data-id="element-65" data-mp="3vaxwv65xhycv">
          Thank you — we have it.
        </p>
        <p className={`type-body max-w-md text-sm ${dark ? 'text-paper/65' : 'text-ink/60'}`} data-id="element-66" data-mp="91wwxmxo6xp7">
          A real person replies within one working day. This is a design
          prototype, so nothing was actually sent.
        </p>
      </div>;
  }
  return <form onSubmit={e => {
    e.preventDefault();
    setSent(true);
  }} className="grid gap-5 sm:grid-cols-2" data-id="element-67" data-mp="1fgnubgnl40eh">
      {fields.map(f => <div key={f.name} className={f.half ? 'sm:col-span-1' : 'sm:col-span-2'} data-id="element-68" data-mp="1rjqhw7z6ge3z">
          <label htmlFor={f.name} className={labelCls} data-id="element-69" data-mp="1witnbtj2kmch">
            {f.label}
          </label>
          {f.type === 'textarea' ? <textarea id={f.name} name={f.name} rows={5} required={f.required} className={inputCls} data-id="element-70" data-mp="21ho64vh1eawl" /> : f.type === 'select' ? <select id={f.name} name={f.name} required={f.required} className={inputCls} defaultValue="" data-id="element-71" data-mp="18red7el1x0qo">
              <option value="" disabled data-id="element-72" data-mp="1iletmcls9sep">
                Select…
              </option>
              {f.options?.map(o => <option key={o} value={o} data-id="element-73" data-mp="q2rd7ahqf1jy">
                  {o}
                </option>)}
            </select> : <input id={f.name} name={f.name} type={f.type ?? 'text'} required={f.required} className={inputCls} data-id="element-74" data-mp="33bzl2d86ew29" />}
        </div>)}

      <div className="flex flex-col gap-4 sm:col-span-2 sm:flex-row sm:items-center" data-id="element-75" data-mp="2uep90pnjb2wa">
        <button type="submit" className={`type-cta rounded-full px-9 py-4 text-[11px] transition-colors ${dark ? 'bg-paper text-coffee hover:bg-oat' : 'bg-coffee text-paper hover:bg-pennant'}`} data-id="element-76" data-mp="2pd9met5pkobs">
          {submitLabel}
        </button>
        {note && <p className={`type-body text-xs ${dark ? 'text-paper/50' : 'text-ink/50'}`} data-id="element-77" data-mp="26na20jktbxep">
            {note}
          </p>}
      </div>
    </form>;
}